import { IUserType } from "./types";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const isAnalyticsEnabled = () => {
    return (
        process.env.NODE_ENV === "production" &&
        Boolean(GA_MEASUREMENT_ID)
    );
};

const isAdminPath = () => {
    return (
        window.location.pathname === "/admin" ||
        window.location.pathname.startsWith("/admin/")
    );
};

export const initAnalytics = () => {
    if (!isAnalyticsEnabled()) {
        return;
    }

    if (isAdminPath()) {
        return;
    }

    if (window.gtag) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
        window.dataLayer!.push(arguments);
    };

    const script = document.createElement("script");

    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

    document.head.appendChild(script);

    window.gtag("js", new Date());

    window.gtag("config", GA_MEASUREMENT_ID!);
};

export const setAnalyticsUser = (
    userId: string,
    userType: IUserType
) => {
    if (!isAnalyticsEnabled() || !window.gtag) {
        return;
    }

    // GA4의 built-in User-ID
    window.gtag("set", {
        user_id: userId,
    });

    // 팜챗 custom user property
    window.gtag("set", "user_properties", {
        user_type: userType,
    });
};

export const clearAnalyticsUser = () => {
    if (!isAnalyticsEnabled() || !window.gtag) {
        return;
    }

    window.gtag("set", {
        user_id: null,
    });

    window.gtag("set", "user_properties", {
        user_type: null,
    });
};